// extracted by mini-css-extract-plugin
export default {"info_block":"style_info_block__g5fWv","text":"style_text__Ose4f"};